import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatListOption, MatSelectionList, MatSelectionListChange } from '@angular/material/list';
import { MatSelect } from '@angular/material/select';
import { ReplaySubject, Subject, take, takeUntil } from 'rxjs';
import { LanguageServices } from 'src/app/services/LanguageServices';
import { RefreshPreferencesServices } from 'src/app/services/RefreshPreferences.service';
import { HTTPService } from 'src/app/services/http.service';
import { MeliServices } from 'src/app/services/meli.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { ThemeService } from 'src/app/services/theme.service';
import { UserAuthenticationServices } from 'src/app/services/user-authentication.services';
import { SearchProperties } from 'src/app/system-utils/search-input-new/search-input-new.component';
import { ObjectUtil } from 'src/app/system-utils/utils/ObjectUtil';
import { Variable } from '../formula-tester/formula-tester.component';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzMessageService } from 'ng-zorro-antd/message';
import { DateUtils } from 'src/app/system-utils/utils/DateUtils';

export interface Pedido{
    erpOrder?: number;
    codecompany?:number;
    pedido?:string;
    companyname?:string;
    status?:string
    mensagem?:string;
    internalid?:number;
    codemktp?:number;
    MktpName?:string;
    full?:boolean;
}

@Component({
    selector: 'push-pedidos',
    templateUrl: './push-pedidos.component.html',
    styleUrls: ['./push-pedidos.component.scss'],
    standalone: false
})
export class PushPedidosComponent implements OnInit {

  @ViewChild('list',{read:MatSelectionList}) list:MatSelectionList;
  
  buscouPedidoMeli = false;
  wait = false;  
  pasting: boolean;
  range: Date[] = [new Date(), DateUtils.addDays(new Date(), 1)];
  loading = false;
  

  constructor( private message:NzMessageService, private cd:ChangeDetectorRef, private http:HTTPService, private user:UserAuthenticationServices,
    public datepipe: DatePipe, private meliServices:MeliServices, 
    public rps:RefreshPreferencesServices,public ThemeService:ThemeService, private ls:LanguageServices,
    private modal: NzModalService) { 

    this.interval = setInterval(()=>{
      this.refresh();
      this.cd.markForCheck();
    },this.time*1000*60)

  }

  empresas:{name:string,codecompany:number}[] = [];
  marketplace:{name:string,codemktp:number}[] =[{name:'Mercado Livre',codemktp:3},{name:'Amazon',codemktp:5},{name:'Vtex',codemktp:6}, {name:'Shopify', codemktp:58}, {name:'Shopee', codemktp:47}, {name:'Amazon PII', codemktp:62}, {name:'SkyHub', codemktp:9}, {name:'Magalu', codemktp:15}, {name:'6Place', codemktp:107},{name:'TrayCorp', codemktp:51}];
  listpedidos:Pedido[] = [];///[{pedido:''}];
  selecteditens:Pedido[] = [];
  listprocessamento:Pedido[] = [];

  time = 10;
  atualizacao:String;
  interval: NodeJS.Timeout;
  selected = false;
  isFull = false;
  selectedMktp = false;
  codecompany:any;
  codemktp:any;
  companyname:string;
  mktpname:string;
  input:string;

  searchInputCodeCompany:SearchProperties ={
          entityName:'Mktpcompanies',
          fields:{keyField:'CODECOMPANY', valueField:'NAME'},
          placeholder:this.ls.instant("CODECOMPANY"),
          showKey:true,
          showPresentation:false,
          size:'default',
          disabled:false
  }

  searchActiveCompanies:SearchProperties ={
          entityName:'Mktpactivecompanies',
          fields:{keyField:'CODEMKTP', valueField:'FK_MKTPACTIVECOMPANIES_MKTPLACES->NAME'},
          placeholder:this.ls.instant("MKTPACTIVECOMPANIES"),
          showKey:true,
          showPresentation:true,
          size:'default',
          disabled:true,
          condition: 'this.CODECOMPANY = {@CODECOMPANY}'
  }

  // range = new UntypedFormGroup({
  //   start: new UntypedFormControl(new Date()),
  //   end: new UntypedFormControl(new Date())
  // });
  variables:Variable[] = [];

  changeCompany:Subject<any> = new Subject<any>();

  onChangeCompanyData(evento){
    console.log(evento);
    
    this.searchActiveCompanies.disabled = true;
    setTimeout(()=>{
        this.searchActiveCompanies.disabled = false;

        let variable = this.variables.find(d=>d.key=='@CODECOMPANY');

        if ( variable == null){
            this.variables.push({
                key:'@CODECOMPANY',
                value:evento?.key,
                type:'texto'
            });
        }else{
            variable.value = evento?.key;
        }
        this.changeCompany.next(evento?.key||"");
        this.searchActiveCompanies.disabled = false;
    },100);
  }
  
  selectFormControl = new UntypedFormControl('', [
    Validators.required
  ])

  selectFormControlMktplace = new UntypedFormControl('', [
    Validators.required
  ])

  refresh(){
    if ( ObjectUtil.isNotEmpty(this.codecompany?.key) &&  ObjectUtil.isNotEmpty(this.codemktp?.key)){
      this.listprocessamento = [];
      this.getPedidos(this.codecompany?.key,this.codemktp?.key);
    }
  }


  getOrderIdMeli(value){
    //this.spinner.show();
    return new Promise((resolve,reject)=>{
      this.wait = true;
      try{
        if ( !this.isFull ){
          
          this.meliServices.getOrderByPackId(value,this.codecompany.key).then((data:string)=>{
            this.input = data;
            this.buscouPedidoMeli  =  true;
            setTimeout(()=>{this.wait = false},100);
            this.cd.markForCheck();
            resolve(data);
          }
        ).catch(r=>{
            this.buscouPedidoMeli  =  true;
            setTimeout(()=>{this.wait = false},100);
            this.cd.markForCheck();
            resolve(value);
            this.http.handleError(r,false);
            
            //this.spinner.hide();
        });
        }else{
          this.meliServices.getInvoice(value,this.codecompany.key).then((data:string)=>{
            
            this.input = data;
            this.buscouPedidoMeli  =  true;
            setTimeout(()=>{this.wait = false},100);
            this.cd.markForCheck();
            resolve(data);
          }
        ).catch(r=>{
            this.buscouPedidoMeli  =  true;
            setTimeout(()=>{this.wait = false},100);
            this.cd.markForCheck();
            resolve(value);
            this.http.handleError(r,false);
          });
        }
        
      
      }catch(Exception){
          this.buscouPedidoMeli  =  true;
          this.cd.markForCheck();
      }
    })
      
  }

  getPedidos(codeCompany:any, codeMktp:any){
    
    if ( ObjectUtil.isNotEmpty(codeCompany)){
      this.loading = true;
      //if ( this.range.get('start').value == null  || this.range.get('end').value == null ){
      if ( this.range[0] == null  || this.range[1] == null ){
          this.message.error(this.ls.instant('push_pedidos.selecionar_datas'));
          this.loading = false;
          return;
      }

      
      this.atualizacao = this.datepipe.transform(new Date(), 'dd/MM/yyyy HH:mm:ss'); 

      let body = {
        "codecompany": codeCompany,
        "codemktp":codeMktp,
        "datainicio":this.range[0],
        "datafinal":this.range[1]
      }
      
      let object:{CODECOMPANY:number,STATUS:string,ERPORDER:string,MENSAGEM:string,INTERNALID:number, MKTPLACEID:string,NAME:string,CODEMKTP:number,MKTPNAME:string}[]  = [];
  
      this.http.post(body,"PushPedidosMeliServices/getPending",false,true,false).subscribe(lista=>{
          object = lista as {CODECOMPANY:number,STATUS:string,ERPORDER:string,MENSAGEM:string,INTERNALID:number, MKTPLACEID:string, NAME:string; CODEMKTP:number, MKTPNAME:string}[] ;
          if ( ObjectUtil.isNotEmpty(object)){
              object.forEach( i => {
                let pedido:Pedido = {
                  codecompany: i.CODECOMPANY,
                  companyname: i.NAME,
                  pedido: i.MKTPLACEID,
                  mensagem: i.MENSAGEM,
                  status: i.STATUS,
                  internalid : i.INTERNALID,
                  erpOrder: i.ERPORDER == null ? 0 : Number.parseInt(i.ERPORDER),
                  codemktp: i.CODEMKTP,
                  MktpName: i.MKTPNAME
                }
                this.listprocessamento.push(pedido);
              })
              this.cd.markForCheck();        
              this.loading = false;
          }
          
  
      }, error=>{
          this.loading = false;
          this.http.handleError(error);
      });
  
    }else{
      this.message.error(this.ls.instant('push_pedidos.selecionar_empresa'));
      this.selectFormControl.markAsTouched();
      this.loading = false;
    }
    
  }

  onPaste(event:ClipboardEvent): void {
    var clipboardData, pastedData;

    // Stop data actually being pasted into div
    event.stopPropagation();
    event.preventDefault();

    let data = event.clipboardData.getData('text/plain');
    //data = data && data.length > 0 ? data : event.clipboardData.getData('text/plain');
    // Do whatever with pasteddata
    data.split('\n').forEach(value=>{
        if ( ObjectUtil.isNotEmpty(value) && value!='' && value.length > 0){
          this.add(value, true);
        }
    });
  }

  save(mktpPlaceId:string, codeMktp:any, codeCompany:any, isFull:boolean){
      let body = {
          "entityName":"Mktpnotifications",
          "CODECOMPANY": codeCompany,
          "TYPE":isFull ? "BuscaOrdersProAtivoFull":"BuscaOrdersProAtivo" ,
          "CODEMKTP":codeMktp,
          "STATUS":"0",
          "MKTPLACEID":mktpPlaceId,
          "MESSAGE":"A Processar",
          "DHIN":this.datepipe.transform(Date(),"yyyy-MM-dd HH:mm:ss")
      } 
      this.http.post(body,"JsonBrokerServices/save",false,true,true).subscribe(p=>{
          this.message.success(this.ls.instant('push_pedidos.pedido_enviado', { mktpPlaceId: mktpPlaceId, codeCompany: codeCompany }));
        let index = this.listpedidos.findIndex(x=> x.pedido ===mktpPlaceId && x.codecompany===codeCompany.key && x.codemktp === codeMktp.key);
          this.listpedidos.splice(index,1);

      }, error=>{
          this.message.error(this.ls.instant('push_pedidos.erro_salvar'));
          throw error;
      });
  }

  ngOnInit(): void {
    
  }

  

  async add(value, clipBoard:boolean = false){

    let ob:Pedido = {
        codecompany: this.codecompany.key,
        pedido: value,
        companyname: this.codecompany.value,
        MktpName: this.mktpname,
        codemktp: this.codemktp.key,
        full: this.isFull
        
    }
    
    if ( ob.pedido!=''){

      if ( clipBoard &&  ob.codemktp == 3 ){
        await this.getOrderIdMeli(ob.pedido).then((data:string)=>{
          ob.pedido = data;
        }).catch(error=>{
          this.message.error(this.ls.instant('push_pedidos.erro_buscar_id'));
          return;
        });
        
      }else{
        if ( ob.codemktp == 3 && !this.buscouPedidoMeli && !this.isFull){
          this.message.error(this.ls.instant('push_pedidos.nao_verificado'));
          return;
        }
        
        if ( ob.codemktp == 3 && !this.buscouPedidoMeli && this.isFull){
          this.message.error(this.ls.instant('push_pedidos.nao_verificado_full'));
          return;
        }
      }
      
      if ( this.listpedidos.findIndex(x=> x.pedido === ob.pedido && x.codecompany===ob.codecompany && x.codemktp === ob.codemktp)>-1){
        this.message.error(this.ls.instant('push_pedidos.pedido_existe'));
        return;
      }

      this.listpedidos.push(ob);
      this.listpedidos = [...this.listpedidos];
    }
    
    this.isFull = false;
    this.buscouPedidoMeli  =  false;
    this.input='';

  }

  ngAfterViewInit(): void {
  }  


  processar(){

      this.listpedidos.forEach(item=>{
          if ( item.pedido != ''){
            this.save(item.pedido,item.codemktp,item.codecompany,item.full);
            this.listprocessamento.push(item);
            this.listprocessamento = [...this.listprocessamento];
          }
          
      });

  }

  remove(event:Pedido){
      let index = this.listpedidos.findIndex(x=> x.pedido === event.pedido && x.codecompany===event.codecompany && x.codemktp === event.codemktp);
      if ( index >-1 ){
        this.listpedidos.splice(index,1);
      }
      this.listpedidos = [...this.listpedidos];
  }

  clear(){
      this.modal.confirm({
        nzTitle: this.ls.instant("push_pedidos.confirmlimparlista"),
        nzOnOk:()=>{
          this.listpedidos = [];
        },
        nzOkText: this.ls.instant("yes"),
        nzCancelText: this.ls.instant("no")
      });
      
  }

  ngOnDestroy(){
      clearInterval(this.interval);
      
    
  }


  
}
